export function centerMapToCoords(mapRef, coords) {
    mapRef.current.flyTo({
        center: coords
    });
}
